import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '../../../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../../../shared/modules/configurable-form/models/on-field-changed';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Injectable()
export class HandlePumpWithLinearMetersCommandUL implements OnFieldChanged {
  constructor() {}

  onFieldChanged(value: string, formGroup: FormGroup, form: ConfigurableFormComponent): void {
    this.resetPumpForm(formGroup);
    form.updateValues(SpecFieldNames.PUMP);
  }

  private resetPumpForm(formGroup: FormGroup): void {
    formGroup.get(SpecFieldNames.PUMP).setValue(undefined);
    formGroup.get(SpecFieldNames.PUMP).disable();
    formGroup.get(SpecFieldNames.PIPE_QUANTITY).setValue(0);
    formGroup.get(SpecFieldNames.HOSES).setValue(0);
    formGroup.get(SpecFieldNames.PUMP_LENGTH).setValue(undefined);
    formGroup.get(SpecFieldNames.LINEAR_METERS).setValue(0);
  }
}
